import { cn } from '@/lib/utils';

interface IconProps { className?: string }

/** Blue envelope glyph used for the "Message" action across listings. */
export function MessageIcon({ className }: IconProps) {
  return (
    <svg viewBox="0 0 24 18" className={cn(className)} aria-hidden="true">
      <path fill="#1e90ff" stroke="#fff" strokeWidth="1.5" strokeLinejoin="round" d="M1 1h22v16H1z" />
      <path fill="none" stroke="#fff" strokeWidth="1.5" strokeLinejoin="round" d="M1 1l11 9 11-9" />
    </svg>
  );
}

/** Official WhatsApp green bubble glyph. */
export function WhatsAppIcon({ className }: IconProps) {
  return (
    <svg viewBox="0 0 32 32" className={cn(className)} aria-hidden="true">
      <path fill="#25D366" d="M16 .5C7.44.5.5 7.44.5 16c0 2.82.74 5.57 2.16 8L.5 31.5l7.74-2.03A15.46 15.46 0 0 0 16 31.5C24.56 31.5 31.5 24.56 31.5 16S24.56.5 16 .5z" />
      <path fill="#fff" d="M23.47 19.4c-.39-.2-2.3-1.13-2.66-1.26-.36-.13-.62-.2-.88.2-.26.39-1 1.26-1.23 1.52-.23.26-.45.3-.84.1-.39-.2-1.65-.61-3.14-1.94-1.16-1.03-1.94-2.3-2.17-2.69-.23-.39-.02-.6.17-.8.18-.17.39-.45.59-.68.2-.23.26-.39.39-.65.13-.26.07-.49-.03-.68-.1-.2-.88-2.13-1.21-2.91-.32-.76-.64-.66-.88-.67l-.75-.01c-.26 0-.68.1-1.03.49-.35.39-1.35 1.32-1.35 3.22 0 1.9 1.38 3.74 1.58 4 .2.26 2.73 4.17 6.61 5.84.92.4 1.64.63 2.2.81.92.29 1.76.25 2.42.15.74-.11 2.3-.94 2.62-1.85.32-.91.32-1.69.23-1.85-.1-.16-.36-.26-.75-.45z" />
    </svg>
  );
}
